import * as actionTypes from "./actionTypes";
import axios from "../../axios-amps";
import { logFirebaseEvent } from "../../shared/utility";
import { serverconfigs } from "../../constants";

export const addNewUpload = (newUploadData) => {
  return {
    type: actionTypes.ADD_NEW_UPLOAD,
    newUploadData: newUploadData,
  };
};
export const fetchBeneficiaryDetailsStarted = () => {
  return {
    type: actionTypes.FETCH_BALANCEBILLING_BENEFICIARY_DETAILS_STARTED,
  };
};
export const fetchBeneficiaryDetailsSuccess = (beneficiaryDetails) => {
  return {
    type: actionTypes.FETCH_BALANCEBILLING_BENEFICIARY_DETAILS_SUCCESS,
    beneficiaryDetails: beneficiaryDetails,
  };
};
export const fetchBeneficiaryDetailsFailed = (errorMessage) => {
  return {
    type: actionTypes.FETCH_BALANCEBILLING_BENEFICIARY_DETAILS_FAILED,
    errorMessage: errorMessage,
  };
};

export const fetchBeneficiaryDetails = (userId: string) => {
  return (dispatch) => {
    dispatch(fetchBeneficiaryDetailsStarted());
    axios
      .get(serverconfigs.bbNewUploadUrl+`?userId=${userId}`)
      .then((response) => {
        console.log(response.data);

        //  const result= [
        //     {
        //       "primaryAccountHolder": true,
        //       "patientName": "SULA MCIVER",
        //       "patientId": 1272025,
        //       "isMinor": false,
        //       "dateOfBirth": "1963-05-01T00:00:00.000Z"
        //     },{
        //       "primaryAccountHolder": false,
        //       "patientName": "PRIYANKA MAHAJAN",
        //       "patientId": 1272026,
        //       "isMinor": false,
        //       "dateOfBirth": "1963-05-01T00:00:00.000Z"
        //     }
        //   ]
        //   dispatch(fetchBeneficiaryDetailsSuccess(result));
        dispatch(fetchBeneficiaryDetailsSuccess(response.data.result));
      })
      .catch((error) => {
        console.log(error.message);
        if (error.statusCode === 400) {
          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            dispatch(
              fetchBeneficiaryDetailsFailed(error.response.data.message)
            );
          } else {
            dispatch(fetchBeneficiaryDetailsFailed(error.message));
          }
          logFirebaseEvent("Exception400");
        } else if (error.statusCode === 401) {
          logFirebaseEvent("Exception401");
          dispatch(fetchBeneficiaryDetailsFailed(error.message));
        } else if (error.statusCode === 500) {
          logFirebaseEvent("Exception500");
          dispatch(fetchBeneficiaryDetailsFailed(error.message));
        } else dispatch(fetchBeneficiaryDetailsFailed("No Claims Available"));
      });
  };
};
